export default {
  set(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get(key, value) {
    return JSON.parse(localStorage.getItem(key));
  },
  remove(key) {
    localStorage.removeItem(key);
  },

  //存储sessionStorage
  setSession(name, content) {
    if (!name) return;
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
  },

  //获取sessionStorage
  getSession(name) {
    if (!name) return null;
    let sessionStorage = window.sessionStorage.getItem(name) || null;
    return JSON.parse(sessionStorage);
  },

  //删除sessionStorage
  removeSession(name) {
    if (!name) return;
    window.sessionStorage.removeItem(name);
  },
};
